export default {
	name: "Storytel Old",
	format: "wav",
	connection: "ftp",
	audio: true,
	disableArticles: ["cd", "mp3cd"],
};
